var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('heading',{attrs:{"helpInfo":_vm.sidebarCard}},[_vm._v(" "+_vm._s(_vm.$t("sidebar.dangerousGoods"))+" ")]),_c('dangerousGoodsStorageLocationTable')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }